import { useMemo } from 'react';

import { BaseInputProps } from '../BaseInput/index.types';
import { StringInputProps } from './index.types';

export function useStringInputController(props: StringInputProps) {
  const {
    value = '',
    onChange,
    suggestions = [],
    placeholder,
    required,
    ...rest
  } = props;

  const options = useMemo(
    () =>
      suggestions.map((suggestion) => ({
        value: suggestion,
        label: suggestion,
      })),
    [suggestions],
  );

  const baseInputProps: BaseInputProps = useMemo(() => {
    let error = false;

    if (required && !value) {
      error = true;
    }

    return {
      ...rest,
      value,
      onChange,
      options,
      placeholder,
      error,
    };
  }, [required, value, rest, onChange, options, placeholder]);

  return {
    baseInputProps,
  };
}
